import { PureComponent } from 'react';

import PropTypes from 'prop-types';

class withCountdown extends PureComponent {
  constructor(props) {
    super(props);
    const { countDownTime } = this.props;
    this.state = { secondsRemaining: countDownTime };

    this.intervalHandle = null;
    this.secondsRemaining = null;

    this.tick = this.tick.bind(this);
    this.startCountDown = this.startCountDown.bind(this);
  }

  componentDidMount() {
    this.startCountDown();
  }

  componentWillUnmount() {
    clearInterval(this.intervalHandle);
  }

  startCountDown() {
    const { countDownTime } = this.props;
    this.intervalHandle = setInterval(this.tick, 1000);
    this.secondsRemaining = countDownTime;
  }

  tick() {
    if (this.secondsRemaining === 0) {
      clearInterval(this.intervalHandle);
      const { callbackAfterTimeOut } = this.props;
      callbackAfterTimeOut();
      return;
    }
    this.secondsRemaining -= 1;
    this.setState({ secondsRemaining: this.secondsRemaining });
  }

  render() {
    const { render } = this.props;
    return render(this.state, this.props);
  }
}

withCountdown.propTypes = {
  countDownTime: PropTypes.number.isRequired,
  callbackAfterTimeOut: PropTypes.func.isRequired,
  render: PropTypes.func.isRequired,
};

export default withCountdown;
